import { defineComponent as t, computed as i, openBlock as r, createElementBlock as s, normalizeClass as l, normalizeStyle as c } from "vue";
import { useThemeConfig as m } from "../../draft/ThemeProvider/context.js";
const d = /* @__PURE__ */ t({
  __name: "v-icon",
  props: {
    variant: {},
    size: { default: 16 },
    i: { default: "question" }
  },
  setup(n) {
    const o = n, a = i(() => o.variant ?? m().iconVariant ?? "solid");
    return (e, p) => (r(), s("i", {
      class: l(["v-icon", [`fa-${a.value}`, `fa-${e.i}`]]),
      style: c([{ "--size": e.size + "px" }])
    }, null, 6));
  }
});
export {
  d as default
};
